import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { UnitInterface } from "../../Entity/Entities/Unit/UnitInterface";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";
import Http from "../../Http/Http";

export default function* unitDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_UNIT_DELETE_REQUEST
    });

    yield call(Http.delete, `units/${action.payload?.unit.id}`);
    const unit: UnitInterface = action.payload?.unit.reinitialize({ removed: true});

    yield put({
      type: Constants.GLOBAL_UNIT_DELETE_SUCCESS,
      payload: {
        unit: unit,
        propertyId: action.payload?.propertyId
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-unit-removed-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_UNIT_DELETE_FAILURE,
      payload: {
        err: err
      }
    });

  }
}

export function* watchUnitDelete() {
  yield takeEvery(Constants.GLOBAL_UNIT_DELETE_START, unitDelete);
}
